var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"clearfix"},[_c('h1',{staticClass:"header_title float_left"},[_vm._v(_vm._s(_vm.contents.chapterTitle))]),_vm._v(" "),_c('p',{staticClass:"studytitle float_right"},[_vm._v(_vm._s(_vm.contents.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }